import { ShareConfirmationModal } from '../../../shared/components/ShareConfirmationModal';
import { SPReferralModal } from '../../sp-client-management/components/SPReferralModal';
import { ReferralModal } from '../../dashboard/financial-advisor/components/ReferralModal';
import { RequestCallModal } from '../../consultations/components/RequestCallModal';
import { IntakeFormModal } from './IntakeFormModal';

export type SelectedProvider = {
  id: string;
  name: string;
};

export type SelectedConsultationProvider = SelectedProvider & {
  calendlyUrl: string | null;
  intakeFormUrl: string | null;
};

type ProviderDirectoryModalsProps = {
  isSP: boolean;
  isFA: boolean;
  selectedProvider: SelectedProvider | null;
  selectedConsultationProvider: SelectedConsultationProvider | null;
  showSharePrompt: boolean;
  setShowSharePrompt: (open: boolean) => void;
  showReferModal: boolean;
  onReferModalClose: (open: boolean) => void;
  callRequestModalOpen: boolean;
  setCallRequestModalOpen: (open: boolean) => void;
  intakeFormModalOpen: boolean;
  setIntakeFormModalOpen: (open: boolean) => void;
  clearSelectedConsultationProvider: () => void;
  onConfirmShare: () => void;
  onCancelShare: () => void;
};

export function ProviderDirectoryModals({
  isSP,
  isFA,
  selectedProvider,
  selectedConsultationProvider,
  showSharePrompt,
  setShowSharePrompt,
  showReferModal,
  onReferModalClose,
  callRequestModalOpen,
  setCallRequestModalOpen,
  intakeFormModalOpen,
  setIntakeFormModalOpen,
  clearSelectedConsultationProvider,
  onConfirmShare,
  onCancelShare,
}: ProviderDirectoryModalsProps) {
  return (
    <>
      {selectedProvider && (
        <ShareConfirmationModal
          open={showSharePrompt}
          onOpenChange={setShowSharePrompt}
          itemType="provider"
          itemName={selectedProvider.name}
          onConfirm={onConfirmShare}
          onCancel={onCancelShare}
        />
      )}
      {isSP && selectedProvider && (
        <SPReferralModal
          open={showReferModal}
          onOpenChange={onReferModalClose}
          providerId={selectedProvider.id}
          providerName={selectedProvider.name}
        />
      )}
      {isFA && selectedProvider && (
        <ReferralModal
          open={showReferModal}
          onOpenChange={onReferModalClose}
          providerId={selectedProvider.id}
          providerName={selectedProvider.name}
        />
      )}
      {selectedConsultationProvider && (
        <>
          {/* Feature 102: primary contact action on directory cards */}
          <RequestCallModal
            open={callRequestModalOpen}
            onOpenChange={(open) => {
              setCallRequestModalOpen(open);
              if (!open) clearSelectedConsultationProvider();
            }}
            providerId={selectedConsultationProvider.id}
            providerName={selectedConsultationProvider.name}
          />
          {selectedConsultationProvider.intakeFormUrl && (
            <IntakeFormModal
              open={intakeFormModalOpen}
              onOpenChange={(open) => {
                setIntakeFormModalOpen(open);
                if (!open) clearSelectedConsultationProvider();
              }}
              providerId={selectedConsultationProvider.id}
              url={selectedConsultationProvider.intakeFormUrl}
            />
          )}
        </>
      )}
    </>
  );
}
